import React from 'react';
import { Route, Switch } from 'react-router';
import universal from '@nerdwallet/coin/universal';
import _ from 'lodash';
import {
  AnalyticsPageView,
  AnalyticsProvider,
} from '@nerdwallet/seo-analytics';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Toaster } from 'react-hot-toast';
import Container from './container';
import ConfigPage from '../containers/config-page/config-page';
import { loadConfigRoute } from '../lib/route-utils';
import { loadIdentity } from '../lib/load-identity';

const BuilderContainer = universal(import('../containers/builder/container'));

export const BUILDER_SLUG = 'builder';

const dataDependencies = [
  {
    path: '/',
    loadData: async (opts, callback) => {
      await loadConfigRoute(opts);
      await loadIdentity(opts);
      callback();
    },
  },
];

const analyticsWrapper = ({ children, flatOutline }) => {
  const pageConfig = _.filter(
    flatOutline,
    (component) => component.type === 'Page'
  )[0];
  const contentId = pageConfig?.contentId;
  return (
    <AnalyticsProvider>
      <AnalyticsPageView
        name="page_view"
        contentSource="wp"
        contentId={contentId}
      >
        {children}
      </AnalyticsPageView>
    </AnalyticsProvider>
  );
};

const ComposedAnalyticsWrapper = connect(
  createStructuredSelector({
    flatOutline: (state) => state?.builder?.flatOutline,
  })
)(analyticsWrapper);

const appFrom = (Component) => () =>
  (
    <ComposedAnalyticsWrapper>
      <Container>
        <Component />
        <Toaster />
      </Container>
    </ComposedAnalyticsWrapper>
  );

export default (
  <Switch dataDependencies={dataDependencies}>
    <Route path={`/l/${BUILDER_SLUG}`} component={appFrom(BuilderContainer)} />
    <Route path="/" component={appFrom(ConfigPage)} />
  </Switch>
);
